import { render } from "./SModal.vue?vue&type=template&id=b5b0bea6"
import script from "./SModal.vue?vue&type=script&lang=js"
export * from "./SModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__